import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

import { PayPalScriptProvider, PayPalButtons } from "@paypal/react-paypal-js";
import { loadStripe } from "@stripe/stripe-js";
import { Elements, CardElement, useStripe, useElements } from "@stripe/react-stripe-js";
import axios from "axios";
import { FaPaypal, FaCreditCard } from "react-icons/fa"; // Icons for better UI



const stripePromise = loadStripe("pk_live_51Qr4S6CEvKVHpVyADGGmLQQ5bd1FuMVnKbqLuQtlmOOL1K9cJ2HQXifmhXm9rsSBQy8po00Sl2Nvw2ghQDyw2hsM004hKVBxlX");

const Donation = () => {


  const BACKURL = process.env.REACT_APP_URL;

  const navigate = useNavigate();

  const [donation, setDonation] = useState({
    name: "",
    email: "",
    purpose: "",
    amount: "",
    selectedAmount: null,
    paymentMethod: "stripe",
    giftAmount: 0, // ✅ Default gift amount set to 0
    selectedGift: null,
  });

  const amounts = [50, 100, 150, 200];

  const handleInputChange = (e) => {
    setDonation({ ...donation, [e.target.name]: e.target.value });
  };

  const handleAmountSelect = (amt) => {
    setDonation({ ...donation, selectedAmount: amt, amount: amt });
  };

  const handleCustomAmount = (e) => {
    setDonation({ ...donation, selectedAmount: null, amount: e.target.value });
  };

  const handleGiftSelect = (amt) => {
    setDonation({ ...donation, selectedGift: amt, giftAmount: amt });
};

const handleCustomGift = (e) => {
    const customGift = e.target.value;
    setDonation({ ...donation, selectedGift: null, giftAmount: customGift });
};


  const handlePayPalPayment = async (order) => {
    try {
      await axios.post(`${BACKURL}/api/paypal-donation`, {
        name: donation.name,
        email: donation.email,
        purpose: donation.purpose,
        amount: donation.amount,
        transaction_id: order.id, // Send the PayPal transaction ID
      });

      alert("Donation successful!");
    } catch (error) {
      console.error("Error processing PayPal donation:", error);
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-r from-blue-500 to-purple-600 flex flex-col justify-center items-center">
      
    {/* Header */}
    <header className="text-white text-center py-6">
      <h1 className="text-4xl font-extrabold tracking-wide">🌟 Make a Difference Today! 🌟</h1>
      <p className="text-lg mt-2 font-light">Your generosity empowers lives and builds a better future.</p>
    </header>

    {/* Donation Form Container */}
    <div className="w-full max-w-3xl bg-white shadow-lg rounded-2xl p-8">
      
      <h2 className="text-3xl font-bold text-center text-gray-800 mb-6">Donate Now</h2>


      {/* Amount Selection */}
      <div className="mb-5">
        <label className="block font-medium text-gray-700">Select Amount</label>
        <div className="grid grid-cols-4 gap-4 mt-2">
          {amounts.map((amt) => (
            <button
              key={amt}
              onClick={() => handleAmountSelect(amt)}
              className={`p-3 border rounded-lg text-lg font-semibold transition-all ${
                donation.selectedAmount === amt ? "bg-blue-500 text-white" : "bg-gray-100 hover:bg-blue-300"
              }`}
            >
              ${amt}
            </button>
          ))}
        </div>
      </div>

      {/* Custom Amount */}
      <div className="mb-5">
        <label className="block font-medium text-gray-700">Custom Amount</label>
        <input 
          type="number"
          name="amount"
          value={donation.amount}
          onChange={handleCustomAmount}
          className="w-full p-3 border rounded-lg focus:ring focus:ring-blue-300"
          placeholder="Enter custom amount"
        />
      </div>

      {/* Name Input */}
      <div className="mb-5">
        <label className="block font-medium text-gray-700">Full Name</label>
        <input 
          type="text" 
          name="name"
          value={donation.name} 
          onChange={handleInputChange} 
          className="w-full p-3 border rounded-lg focus:ring focus:ring-blue-300"
          placeholder="Enter your name"
        />
      </div>

      {/* Email Input */}
      <div className="mb-5">
        <label className="block font-medium text-gray-700">Email Address</label>
        <input 
          type="email" 
          name="email"
          value={donation.email} 
          onChange={handleInputChange} 
          className="w-full p-3 border rounded-lg focus:ring focus:ring-blue-300"
          placeholder="Enter your email"
        />
      </div>

      {/* Donation Purpose */}
      <div className="mb-5">
        <label className="block font-medium text-gray-700">Donation Purpose</label>
        <input 
          type="text" 
          name="purpose"
          value={donation.purpose} 
          onChange={handleInputChange} 
          className="w-full p-3 border rounded-lg focus:ring focus:ring-blue-300"
          placeholder="Enter donation purpose"
        />
      </div>

      {/* Total Amount Display */}
<div className="text-center mt-4">
    <h3 className="text-2xl font-bold text-gray-800">Total</h3>
    <p className="text-3xl font-bold text-gray-900">${donation.amount ? parseFloat(donation.amount).toFixed(2) : "0.00"}</p>
</div>



{/* Optional Gift Section */}
<div className="mt-6 p-4 bg-gray-100 rounded-lg shadow">
    <h3 className="text-lg font-bold text-gray-700">🎁 Add an Optional Gift</h3>
    <p className="text-sm text-gray-600">
        Your additional support helps us continue our mission.
    </p>
    
    <div className="grid grid-cols-5 gap-2 mt-3">
        {[5, 10, 25, 50].map((amt) => (
            <button
                key={amt}
                onClick={() => handleGiftSelect(amt)}
                className={`p-2 border rounded-lg text-sm font-semibold transition-all ${
                    donation.selectedGift === amt ? "bg-green-500 text-white" : "bg-gray-200 hover:bg-green-300"
                }`}
            >
                Give ${amt.toFixed(2)}
            </button>
        ))}
        {/* Custom Gift Input */}
        <input 
            type="number"
            name="giftAmount"
            value={donation.giftAmount}
            onChange={handleCustomGift}
            className="w-full p-2 border rounded-lg text-center"
            placeholder="Custom"
        />
    </div>
</div>


{/* Total Amount Display */}
<div className="text-center mt-6">
    <h3 className="text-2xl font-bold text-gray-800">Total Donation</h3>
    <p className="text-3xl font-bold text-gray-900">
        ${((parseFloat(donation.amount) || 0) + (parseFloat(donation.giftAmount) || 0)).toFixed(2)}
    </p>
</div>





      {/* Payment Method Selection */}
      <div className="mb-5">
        <label className="block font-medium text-gray-700 text-lg">Select Payment Method</label>
        <div className="flex justify-center space-x-6 mt-3">
          {/* PayPal Button */}
          <button
            onClick={() => handleInputChange({ target: { name: "paymentMethod", value: "paypal" } })}
            className={`flex items-center space-x-2 px-6 py-3 rounded-lg font-bold text-lg transition-all shadow-md ${
              donation.paymentMethod === "paypal" ? "bg-blue-600 text-white" : "bg-gray-100 hover:bg-blue-200"
            }`}
          >
            <FaPaypal className="text-2xl" />
            <span>Pay with PayPal</span>
          </button>

          {/* Stripe (Credit/Debit Card) */}
          <button
            onClick={() => handleInputChange({ target: { name: "paymentMethod", value: "stripe" } })}
            className={`flex items-center space-x-2 px-6 py-3 rounded-lg font-bold text-lg transition-all shadow-md ${
              donation.paymentMethod === "stripe" ? "bg-blue-600 text-white" : "bg-gray-100 hover:bg-blue-200"
            }`}
          >
            <FaCreditCard className="text-2xl" />
            <span>Pay with Card</span>
          </button>
        </div>
      </div>

      {/* PayPal Payment */}
      {donation.paymentMethod === "paypal" && (
        <PayPalScriptProvider options={{ "client-id": "AVDjQfcwSqXsFRspjfj1KJQSWjUDXB3VQy0xkaEgVFxf_TEfJos93-J-ZVmA6fv_H1KlXr4GVOH385Qb" }}>
          <div className="flex justify-center">
            <PayPalButtons
              style={{ layout: "horizontal", color: "blue", shape: "rect", label: "pay" }}
              createOrder={(data, actions) => {
                return actions.order.create({
                  purchase_units: [{ amount: { value: donation.amount } }],
                });
              }}
              onApprove={async (data, actions) => {
                const order = await actions.order.capture();
                handlePayPalPayment(order);
              }}
            />
          </div>
        </PayPalScriptProvider>
      )}

      {/* Stripe Payment */}
      {donation.paymentMethod === "stripe" && (
        <Elements stripe={stripePromise}>
          <div className="mt-4">
          
            <StripeCheckout donation={donation} navigate={navigate} />
          </div>
        </Elements>
      )}
    </div>
  </div>
  );
};



const StripeCheckout = ({ donation,navigate  }) => {
  const stripe = useStripe();
  const elements = useElements();
  const BACKURL = process.env.REACT_APP_URL;

  const [error, setError] = useState();

  const handleStripePayment = async (e) => {


    console.log("🔵 Stripe Button Clicked");
    e.preventDefault();
    if (!stripe || !elements) {
      console.error("🔴 Stripe.js has not loaded yet.");
      return;
    }
    console.log("🟢 Stripe.js Loaded Successfully");

    setError(""); // Clear previous errors

    const { error, paymentMethod } = await stripe.createPaymentMethod({
      type: "card",
      card: elements.getElement(CardElement),
    });

   

    console.log("after create payment method success called");

    if (error) {
      console.error("🔴 Error Creating Payment Method:", error);
      setError(mapStripeError(error)); // Convert raw error into friendly text

      return;
    }

    console.log("🟢 Payment Method Created:", paymentMethod);

    // Check if donation data is correctly passed
    console.log("💰 Donation Data:", donation);


    try {
      console.log("📤 Sending Payment Request to Backend...");
      const response = await axios.post(`${BACKURL}/api/stripe-payment`, {

      
        paymentMethod,
        amount: donation.amount,
        giftAmount: donation.giftAmount || 0, // ✅ Send gift amount

        name: donation.name,
        email: donation.email,
        purpose: donation.purpose,
        
      });
      console.log("🟢 Stripe Payment Success Response:", response.data);

      alert("🎉 Stripe Payment Successful!");
      // Redirect to Thank You Page
      navigate("/thank-you");
    } catch (error) {
      console.error("Stripe Payment Error:", error);
      alert("❌ Stripe Payment Failed. Check the console for details.");
    }
  };

  const mapStripeError = (error) => {
    if (!error) return "⚠️ An unexpected error occurred. Please try again.";

    const { type, code, message } = error;

    const errorMessages = {
        "card_declined": "⚠️ Your card was declined. Please use a different payment method.",
        "incorrect_cvc": "⚠️ The CVC code is incorrect. Please check and try again.",
        "insufficient_funds": "⚠️ Insufficient funds. Please use a different card.",
        "expired_card": "⚠️ Your card has expired. Please use a different card.",
        "processing_error": "⚠️ A processing error occurred. Please try again.",
        "authentication_required": "⚠️ Your bank requires additional authentication. Please check your email or SMS.",
        "live_mode_test_card": "⚠️ You used a test card in live mode. Please use a real card.",
    };

    return errorMessages[code] || message || "⚠️ Payment failed. Please try again.";
};


  return (
    <form onSubmit={handleStripePayment} className="mt-4">

      {/* Display Error Messages */}
{error && (
    <div className="mt-4 p-3 bg-red-100 border border-red-400 text-red-700 rounded">
        {error}
    </div>
)}
      <CardElement className="p-2 border rounded" />
      <button type="submit" className="mt-4 w-full bg-blue-500 text-white p-2 rounded" disabled={!stripe}>
        Pay with Stripe
      </button>
    </form>
  );
};

export default Donation;
